// @flow
import * as apps from 'app/common/constants/services';


// приложения, данные из которых выводятся на странице "Мои дети"
export default [apps.APP_DNEVNIK, apps.APP_CAFETERIA, apps.APP_ACCESS];
